(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DeskproAppsSDKCore", [], factory);
	else if(typeof exports === 'object')
		exports["DeskproAppsSDKCore"] = factory();
	else
		root["DeskproAppsSDKCore"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition